export function checkPermission(requiredRoles) {
    const userRoles = this.$store.getters.permissions
    return userRoles.some(role => requiredRoles.includes(role))
  }


// WEBPACK FOOTER //
// ./src/utils/hasPermission.js